module.exports = [{
      plugin: require('/tmp/20509d60/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":1168,"withWebp":true,"linkImagesToOriginal":false},
    },{
      plugin: require('/tmp/20509d60/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/tmp/20509d60/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
